import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, switchMap, take } from 'rxjs/operators';
import { AuthService } from '@ng-shared';
import { VendorService } from '../services/vendorService';

export const appPreloadGuard: CanActivateFn = (): Observable<boolean> => {
    const authService   = inject(AuthService);
    const vendorService = inject(VendorService);
    const router        = inject(Router);

    // Synchronous localStorage token check — updates isAuthenticated$ BehaviorSubject.
    authService.checkAuthentication();

    return authService.isAuthenticated$.pipe(
        // CRITICAL: BehaviorSubject never completes; take(1) lets the guard resolve.
        take(1),
        switchMap((isAuthenticated: boolean) => {
            if (!isAuthenticated) {
                router.navigate(['/login']);
                return of(false);
            }

            // Already loaded — SPA re-navigation, skip the API call.
            if (vendorService.currentVendor) {
                return of(true);
            }

            return vendorService.initializeAppData();
        }),
        catchError(() => {
            router.navigate(['/login']);
            return of(false);
        }),
    );
};
